import { Button } from "~/react/ui/button"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter, SheetBody } from "~/react/ui/sheet"
import { Alert, AlertDescription, AlertIcon, AlertContent } from "~/react/ui/alert"
import EmailAccountProfileTab from "~/react/components/email_accounts/tabs/email_account_profile_tab"
import type { EmailAccount } from "~/react/components/email_accounts/email_accounts_filters"
import type { BulkEditData } from "../hooks/use-bulk-edit"

type BulkEditSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  error: string | null
  loading: boolean
  bulkEditAccount: EmailAccount
  formData: BulkEditData
  setFormData: React.Dispatch<React.SetStateAction<BulkEditData>>
  onSubmit: () => void | Promise<void>
}

export function BulkEditSheet({
  open,
  onOpenChange,
  count,
  error,
  loading,
  bulkEditAccount,
  formData,
  setFormData,
  onSubmit,
}: BulkEditSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} modal={false}>
      <SheetContent className="p-0" overlay={false} side="right" size="md">
        <SheetHeader className="d-flex flex-column align-items-start gap-1">
          <SheetTitle className="w-100">{i18n.t("js.email_accounts_center.bulk.edit_title", { count })}</SheetTitle>
          <span className="text-body-secondary w-100">
            {i18n.t("js.email_accounts_center.bulk.edit_changes_notice") ||
              i18n.t("js.email_accounts_center.bulk.edit_description")}
          </span>
        </SheetHeader>

        <SheetBody className="h-100">
          {error && (
            <Alert variant="destructive" className="mb-4">
              <AlertIcon>!</AlertIcon>
              <AlertContent>
                <AlertDescription>{error}</AlertDescription>
              </AlertContent>
            </Alert>
          )}

          <EmailAccountProfileTab account={bulkEditAccount} formData={formData} setFormData={setFormData} />
        </SheetBody>

        <SheetFooter sticky={true}>
          <Button variant="primary" type="button" onClick={onSubmit} disabled={loading}>
            {loading ? i18n.t("js.loading") : i18n.t("js.save_changes")}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
